import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Constants from './plugins/Constants.js';
import ItemComponent from '@/components/ItemComponent.vue';
import { state } from '@/event-bus';
//import { stateProject } from "@/event-busProject";
//import ProjectsComponent from './components/ProjectsComponent.vue';
import OfertasComponent from '@/components/OfertasComponent.vue';
import OfertaDetailComponent from '@/components/OfertaDetailComponent.vue';
Vue.use(Router);
Vue.use(Constants);
export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/principal',
      component: () => import('./views/Principal.vue'),
    },

    {
      path: '/usuarios',
      component: () => import('./views/Usuarios.vue'),
    },
    {
      path: '/trabajadores',
      component: () => import('./views/Trabajadores.vue'),
    },
    {
      path: '/externos',
      component: () => import('./views/externo.vue'),
    },
    {
      path: '/clientes',
      component: () => import('./views/Clientes.vue'),
    },
    {
      path: '/items',
      component: ItemComponent,
      props: () => {
        const pending = state.pendingItem || {};
        return {
          numeroOferta: pending.numeroOferta || '',
          propietarioNombre: pending.propietarioNombre || '',
          openTraining: pending.openTraining || false,
          optionsSectores: pending.optionsSectores || [],
        };
      },
    },
    {
      path: '/project',
      name: 'detalle-projects',
      component: () => import('./components/Crud.vue'),
      props: {
        current: 'projects-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsTableFields,
        type: 'project',
      },
    },

    {
      path: '/proyectos',
      component: () => import('./views/Proyectos.vue'),
    },
    {
      path: '/ofertas',
      name: 'ofertas',
      component: OfertasComponent,
    },
    {
      path: '/oferta/:id',
      name: 'detalle-oferta',
      component: OfertaDetailComponent,
      props: true,
    },
    {
      path: '/opcionales',
      name: 'opcionales',
      component: () => import('@/components/OpcionalesComponent.vue'),
    },
    {
      path: '/memoriasrepsol',
      component: () => import('./views/Memoriasrepsol.vue'),
    },

    {
      path: '/projects',
      name: 'detalle-proyecto',
      component: () => import('./components/Crud.vue'),
      props: {
        current: 'projects-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsTableFields,
        type: 'project',
      },
    },
    {
      path: '/cursosAmazon',
      name: 'cursosAmazon',
      component: () => import('./components/CrudAmazon.vue'),
      props: {
        current: 'projects-dynamic',
        mainTableFields: Vue.prototype.$constants().cursosAmazonTableFields,
        type: 'cursosAmazon',
      },
    },
    {
      path: '/facturacionInforme',
      component: () => import('./components/FacturacionComponent.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'facturacionInforme',
      },
    },
    {
      path: '/facturacionInformeNueva',
      component: () => import('./components/facturacionantiguaok.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'facturacionInforme',
      },
    },
    {
      path: '/facturacionArchivoNavision',
      component: () => import('./components/ArchivoNavisionComponent.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'facturacionInforme',
      },
    },
    {
      path: '/facturacionInformation',
      component: () =>
        import('./components/FacturacionInformationAmazonComponent.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'facturacionInformation',
      },
    },
    {
      path: '/facturacionSafety',
      component: () =>
        import('./components/FacturacionSafetyAmazonComponent.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'facturacionInformation',
      },
    },
    {
      path: '/provisionInforme',
      component: () => import('./components/ProvisionComponent.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'provisionInforme',
      },
    },
    {
      path: '/provisionInformePOC',
      component: () => import('./components/ProvisionComponentPOC.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'provisionInformePOC',
      },
    },
    {
      path: '/desprovisionInformePOC',
      component: () => import('./components/DesprovisionComponentPOC.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'provisionInformePOC',
      },
    },
    {
      path: '/desprovisionInforme',
      component: () => import('./components/DesprovisionComponent.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'desprovisionInforme',
      },
    },
    {
      path: '/pbi/calidad',
      name: 'pbi-calidad',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'calidad',
      },
    },
    {
      path: '/pbi/encuestas',
      name: 'pbi-encuestas',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'encuestas',
      },
    },
    {
      path: '/pbi/produccionIndividualPersonalizada',
      name: 'pbi-produccion-individual-personalizada',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'produccionIndividualPersonalizada',
      },
    },
    {
      path: '/pbi/contabilidad',
      name: 'pbi-contabilidad',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'contabilidad',
      },
    },
    {
      path: '/pbi/costePersonal',
      name: 'pbi-coste-personal',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'costePersonal',
      },
    },
    {
      path: '/pbi/rentabilidadProyecto',
      name: 'pbi-rentabilidad-proyecto',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'rentabilidadProyecto',
      },
    },
       {
      path: '/pbi/apoyoConsultoria',
      name: 'apoyoConsultoria',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'apoyoConsultoria',
      },
    },
    {
      path: '/pbi/rentabilidadProyectoMensual',
      name: 'pbi-rentabilidad-proyecto-mensual',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'rentabilidadProyectoMensual',
      },
    },
    {
      path: '/pbi/estadoCobro',
      name: 'pbi-estado-cobro',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'estadoCobro',
      },
    },
    {
      path: '/pbi/lideresServicio',
      name: 'pbi-lideres-servicio',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'lideresServicio',
      },
    },
    {
      path: '/pbi/prevision',
      name: 'pbi-prevision',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'prevision',
      },
    },
    {
      path: '/pbi/informeConsultoresDAT',
      name: 'pbi-informe-consultores-dat',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'informeConsultoresDAT',
      },
    },
    {
      path: '/pbi/produccion',
      name: 'pbi-produccion',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'produccion',
      },
    },
    {
      path: '/pbi/facturasPendientes',
      name: 'pbi-facturasPendientes',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'facturasPendientes',
      },
    },

    {
      path: '/pbi/horas',
      name: 'pbi-horas',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'horas',
      },
    },
    {
      path: '/pbi/tms',
      name: 'pbi-tms',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'tms',
      },
    },
    {
      path: '/pbi/produccion-individual',
      name: 'pbi-produccion-individual',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'produccionIndividual',
      },
    },
    {
      path: '/pbi/resumenEjecutivo',
      name: 'pbi-resumen-ejecutivo',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'resumenEjecutivo',
      },
    },
    {
      path: '/pbi/resumenEjecutivoPersonalizado',
      name: 'pbi-resumen-ejecutivo',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'resumenEjecutivoPersonalizado',
      },
    },
    {
      path: '/pbi/tasaOcupacion',
      name: 'pbi-tasa-ocupacion',
      component: () => import('./components/powerbi.vue'),
      props: {
        nombreReporte: 'tasaOcupacion',
      },
    },
    {
      path: '/projectsInforme',
      component: () => import('./components/InformeEncuestaComponent.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsFinishedTableFields,
        type: 'projectInforme',
      },
    },
    {
      path: '/projectsListaInforme',
      component: () => import('./components/InformeProyectosComponent.vue'),
      props: {
        current: 'projectsFinished-dynamic',
        mainTableFields: Vue.prototype.$constants().projectsStateTableFields,
        type: 'projectInforme',
      },
    },
    {
      path: '/projectsSesameInforme',
      component: () => import('./components/HorasSesame.vue'),
    },
    {
      path: '/projectCategoriaInforme',
      component: () => import('./components/CategoriaConsultor.vue'),
    },
    {
      path: '/capacidadConsultor',
      component: () => import('./components/CapacidadConsultor.vue'),
    },
    {
      path: '/projectsNavisionInforme',
      component: () => import('./components/CostesNavision.vue'),
    },
    {
      path: '/horas',
      component: () => import('./components/ImputacionHoras.vue'),
    },

    {
      path: '/informes',
      component: () => import('./components/Crud.vue'),

      props: {
        current: 'informes-dynamic',
        mainTableFields: Vue.prototype.$constants().horasTableFields,
        type: 'informes',
      },
    },
    {
      path: '/calendar',
      component: () => import('./components/Calendar.vue'),
    },
    {
      path: '/participante/:id?',
      name: 'Participante',
      component: () => import('./views/Participantes.vue'),
      props: true,
    },
    {
      path: '/catalogo-curso/:id?',
      name: 'CatalogoCurso',
      component: () => import('./views/CatalogosCurso.vue'),
      props: true,
    },
    {
      path: '/curso/:id?',
      name: 'Curso',
      component: () => import('./views/Cursos.vue'),
      props: true,
    },
    {
      path: '/formador/:id?',
      name: 'Formador',
      component: () => import('./views/Formadores.vue'),
      props: true,
    },
    {
      path: '/elemento-comprobacion/:id?',
      name: 'ElementoComprobación',
      component: () => import('./views/ElementosComprobacion.vue'),
      props: true,
    },
    {
      path: '/encuesta-satisfaccion/:id?',
      name: 'EncuestaSatisfaccion',
      component: () => import('./views/EncuestasSatisfaccion.vue'),
      props: true,
    },
    {
      path: '/examen-curso/:id?',
      name: 'ExamenCurso',
      component: () => import('./views/ExamenesCurso.vue'),
      props: true,
    },
    {
      path: '/configuracion-pbi',
      name: 'configuracion-pbi',
      component: () => import('./views/ConfiguracionPbi.vue'),
    },
  ],
});
